<template>
  <GridPart
      maxWidth="calc(100% - 80px)"
      :title="title"
      :hasSearch="true"
      :hasFilter="false"
      :hasExtra="true"
      :standardClass="() => {}"
      :extraClass="() => {}"
      :colspan="4"
      empty="Nenašli sa žiadne provízie."
      itemsKey="ticketCommissions"
      filterKey="TicketCommission"
      defaultOrder="ticcom.workedAt"
      defaultBy="DESC"
      :defaultLimit="25"
      :fetchData="fetchData"
  >
    <template
        v-slot:action="{
          init
        }"
    >
      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
      >
        <template
            v-if="Ticket.ticketCommissionCreatable"
        >
          <CreateTicket
              :ticketId="Ticket.id"
              @onCreateTicket="(response) => {
                init()

                $emit('refresh', response)
              }"
          />

          &nbsp;
        </template>
      </template>
    </template>

    <template
        v-slot:search="{
          params,
          errors,
          setSearch
        }"
    >
      <v-text-field
          v-model="params.query"
          :error-messages="errors.query"
          :outlined="true"
          :dense="true"
          hide-details="auto"
          label="Vyhľadávanie"
          :clearable="true"
          @change="setSearch"
      />
    </template>

    <template
        v-slot:list-head="{
          order,
          by,
          orderList,
          byList,
          setOrderBy
        }"
    >
      <th
          class="fixed"
      >
        <OrderList
            orderKey="ticcom.workedAt"
            :order="order"
            :by="by"
            :orderList="orderList"
            :byList="byList"
            @setOrderBy="setOrderBy"
        />
      </th>

      <th>
        Užívateľ
      </th>

      <th>
        Suma
      </th>

      <th
          class="text-right fixed"
      />
    </template>

    <template
        v-slot:list-body-standard="{
          Item,
          init
        }"
    >
      <td
          class="fixed"
      >
        {{ Item.workedAt|moment('DD.MM.YYYY') }}
      </td>

      <td>
        <TruncateHelper
            :title="Item.User.name"
            maxWidth="300px"
        >
          {{ Item.User.name }}
        </TruncateHelper>
      </td>

      <td>
        {{ Item.price|currency('€') }}
      </td>

      <td
          class="text-right fixed"
      >
        <template
            v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
        >
          <template
              v-if="Item.updatable"
          >
            <Update
                :id="Item.id"
                @onUpdate="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>

          <template
              v-if="Item.deletable"
          >
            &nbsp;

            <Delete
                :id="Item.id"
                @onDelete="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>
        </template>
      </td>
    </template>

    <template
        v-slot:list-body-extra="{
          Item
        }"
    >
      <td
          :colspan="4"
      >
        <IsEmptyHelper
            :value="Item.note"
            if-no="i"
            if-yes="i"
            empty="bez poznámky"
        >
          {{ Item.note }}
        </IsEmptyHelper>
      </td>
    </template>
  </GridPart>
</template>

<script>
  import TicketCommissions from '@/services/ticket-commissions'

  import CreateTicket from '@/components/TicketCommissions/CreateTicket'
  import Update from '@/components/TicketCommissions/Update'
  import Delete from '@/components/TicketCommissions/Delete'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketCommissions',
    props: [
      'Ticket'
    ],
    emits: [
      'refresh'
    ],
    components: {
      CreateTicket,
      Update,
      Delete,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper
    },
    data() {
      return {
        title: 'Provízie'
      }
    },
    methods: {
      fetchData(params) {
        return TicketCommissions
          .indexTicket({
            ticketId: this.Ticket.id,
            params: params
          })
      }
    }
  }
</script>
